module.exports = __webpack_public_path__ + "static/media/capstone_permissions.e3cbd9a4.yaml";